import { Component, OnInit,ViewChild,ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { FdrsClientService } from 'src/app/service/fdrs-client.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
declare var $: any;
@Component({
  selector: 'app-draggablemodal1',
  templateUrl: './draggablemodal1.component.html',
  styleUrls: ['./draggablemodal1.component.scss']
})
export class Draggablemodal1Component implements OnInit {
  dialogValue: string | undefined;
  isFDRSConnected: boolean = false;
  isRoadsideSession: boolean = false; 
  @ViewChild('importDTCConfirmPopup') importDTC: ElementRef | undefined;

  constructor(
    public activeModal: NgbActiveModal,public service:ApifirstService, public modalService: NgbModal, public router : Router,private fdrsClient: FdrsClientService,public translate: TranslateService) { }
  successMessage:any
  text:any
  test1:any;
  test2:any;
  userId:any
  username:any
  Vinnumber:any
  tokenDetails:any
  saveInProgress: boolean = false;
  ngOnInit() {
    this.test1=this.translate.instant('CAPTURE SYMPTOMS');
    this.test2=this.translate.instant('CLOSE');
    //update page number -- Need to check the usecase. 
    // const req= {
    //   "sessionId":localStorage.getItem("sessionID"),
    //   "pageid":"1"
    //   }
    // this.service.updatePage(req).subscribe(data=>{}) 
     
    this.isFDRSConnected = this.fdrsClient.isFdrsConnected();
    this.service.tokenObj.subscribe((data:any)=>{
      this.username=data.username
    })
    this.service.tokenObj.subscribe((data:any)=>{
      this.tokenDetails=data
    })
    this.Vinnumber = this.tokenDetails.vin

    $(document).ready(function(){
      let modalContent: any = $('.modal-content');     
      modalContent.draggable({
      handle: '#full-width2'
      });
    });
    if (!$(".modal.in").length) {
      $(".modal-dialog").css({
        top: 100,
        left: 0,        
      });
    }
  }
  capture() {
    let sessionId:any = localStorage.getItem("newSessionID")
    localStorage.setItem("sessionID",sessionId);
    this.service.userId.subscribe((data)=>{this.userId=data})
    const request= {
      sessionId:localStorage.getItem("sessionID"),
      comment:this.text,
      dtcInfo:"No",
      dtcListView: [{}]
      };
      this.saveInProgress = true;
      this.service.insertSymptoms(request)
      .subscribe((data) => {
        this.successMessage=data
        console.log("this.successmessage",this.successMessage)
        localStorage.setItem("sessionID",this.successMessage)
        console.log("this.isRoadsideSession",this.isRoadsideSession)
        if(this.isRoadsideSession){
         console.log("going inside the loop")
        const mobileReq = {
          "vin": this.Vinnumber,
          "mobileVehicle": this.isRoadsideSession,
          "resumedByAnotherDealer": false,
          "sessionId": localStorage.getItem("sessionID"),
          "createdTimestamp": new Date().toISOString(),
          "username": this.username,
          "dealerCode": this.tokenDetails.dealerCode
        };

        this.service.setMobileVanSession(mobileReq).subscribe({
        next: (response) => console.log("Mobile session updated", response),
        error: (err) => console.error("Error updating mobile session", err)
      });

      }
        this.saveInProgress = false;
        this.activeModal.close('close');
        this.service.fromCapture.next(false)
        this.router.navigate(['/symptoms'])
       });
    };

  captureSymptoms() {
    localStorage.setItem("manualDiagBtnClick", " ")
    this.modalService.open(this.importDTC, { size: 'md' });
  }

  dismissDTCConfirmPopup() {
   this.capture();
  }

  navigateDTCView() {
    let sessionId:any = localStorage.getItem("newSessionID")
    localStorage.setItem("sessionID",sessionId);
    this.service.captureCustomerComments.next({
      'sessionId':localStorage.getItem("sessionID"),
      'comment':this.text
    })
    this.activeModal.close('close');
    this.router.navigate(['/importDTCView'])
  }
}

